import { NavItem } from 'common/HorizontalNavPage';
import { PermissionName } from '@utmost.co/enterprise-models';
import { useSftpIntl } from './translations/useSftpIntl';

export enum SFTP_TABS {
  SSH_KEYS = 'ssh-keys',
  SFTP_DIRECTORIES = 'sftp-directories'
}

export const useNavItems = (): NavItem[] => {
  const intl = useSftpIntl();

  return [
    {
      label: intl.sftpDirectories,
      path: SFTP_TABS.SFTP_DIRECTORIES,
      'data-test': 'sftp-directories',
      permissions: [{ name: 'SETTINGS_SFTP', action: 'READ' }]
    },
    {
      label: intl.sshKeys,
      path: SFTP_TABS.SSH_KEYS,
      'data-test': 'ssh-keys',
      permissions: [{ name: 'SSH_KEY', action: 'READ' }]
    }
  ];
};

export const PERMISSION_ROUTE_MAP: Partial<PermissionMap> = {
  SETTINGS_SFTP: SFTP_TABS.SSH_KEYS
};

type PermissionMap = {
  [E in PermissionName]: SFTP_TABS;
};
